const getState = (state: AppState) => state.dashboard;

export const dashboardSelector = {
  getState,
};
